import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import World from "@frog/source/models/World.js"
import Delta from "@frog/source/models/Delta.js"
import Stage from "@frog/source/models/Stage.js"
import Objdict from "objdict"

import * as Motions from "@frog/source/juice/utility/Motions.js"
import Timings from "@frog/source/juice/utility/Timings.js"
import {colortween, tween} from "@frog/source/juice/utility/Tweens.js"

import skills from "@frog/source/data/skills.js"
import animations from "@frog/source/juice/animations.js"
import app from "@frog/source/models/App.js"

// import FMODManager from "@frog/source/utility/FMOD/FMODManager.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

// TODO: Combine with Step.js
export default class Step {
    static copy(step) {
        const copystep = {}
        for(let key in step) {
            copystep[key] = step[key]
        }
        return copystep
        // return {
        //     "type": step.type, // "move" | "invoke skill" | "death",
        //     "alphastage": step.alphastage,
        //     "omegastage": step.omegastage,
        //     "deltastages": step.deltastages,
        //     // TOOD: ALL OF THIS IS COPY BY REFERENCE...?
        // }
    }
    static instantiate(step) {
        step.hasStarted = false
        step.hasFinished = false
        step.isInstantiated = true
        step.time = 0 // in milliseconds

        if(step.func != undefined) return step

        if(step.alphastage != undefined) {
            step.stage = Stage.copy(step.alphastage)
        }
        if(animations[step.type] != undefined) {
            step.animation = animations[step.type || "invoke skill"](step)
        }
        if(step.animation != undefined) {
            step.animation = Step.processAnimation(step.animation)
        }

        return step
    }
    static updateStep(step, delta) {
        step.hasStarted = true

        step.time += delta.ms
        step.accumulatedTime += delta.ms

        while(step.sequence.length > 0) {
            if(step.sequence[0] instanceof Function) {
                step.sequence[0].call()
                step.sequence.shift()
                continue
            }
            if(step.sequence[0].execute instanceof Function) {
                step.sequence[0].execute(step.time)
            }
            if(step.sequence[0].duration != undefined) {
                if(step.accumulatedTime > step.sequence[0].duration) {
                    step.accumulatedTime -= step.sequence[0].duration
                    step.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // else {
            // step.sequence.shift()
            // continue
            // }
            if(step.sequence[0].condition != undefined) {
                if(!!step.sequence[0].condition()) {
                    step.sequence.shift()
                    continue
                } else {
                    break
                }
            }
            // if(step.sequence[0].isUnskippable == true) {
            //     step.sequence.shift()
            //     return
            // }
        }

        if(step.sequence.length == 0) {
            Step.finish(step)
        }
    }
    static finish(step) {
        step.hasFinished = true

        if(step.onFinish instanceof Function) {
            step.onFinish()
        }
    }
    // accepts: an array of either keyframes or subarrays of keyframes.
    // outputs: an array of keyframes
    static flattenKeyframes(keyframes) {
        let output = []
        keyframes.forEach((keyframe) => {
            if(keyframe instanceof Array) {
                output = output.concat(Step.flattenKeyframes(keyframe))
            } else {
                output.push(keyframe)
            }
        })
        return output
    }
    static processAnimation(animation) {
        animation.maxmark = 0

        // Flatten arrays of arrays of arrays of keyframes to just a single array of keyframes.
        animation.keyframes = Step.flattenKeyframes(animation.keyframes)

        // Remove any undefined keyframes, like conditionally skipped keyframes.
        animation.keyframes = animation.keyframes.filter((keyframe) => !!keyframe)

        // Separate each keyframe into their own timeline,
        // each for a different property.
        animation.timelines = {}
        animation.keyframes.forEach((keyframe) => {
            if(keyframe.dialogue != undefined) {
                animation.timelines["dialogue"] = animation.timelines["dialogue"] || []
                animation.timelines["dialogue"].push({
                    "mark": keyframe.mark,
                    "timing": keyframe.timing,
                    "motion": keyframe.motion,
                    "dialogue": keyframe.dialogue
                })
            }
            // KEYFRAME SCHEMA v2 - a frame with timing and motion and a mark
            // to know when it happens, and then an object to be Delta.editStage'd,
            // currently only supporting keyframe.unit and keyframe.player
            if(keyframe.unit != undefined) {
                Object.keys(keyframe.unit).forEach((property) => {
                    if(property == "key") return
                    const timelineKey = keyframe.unit.key + "." + property

                    animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                    animation.timelines[timelineKey].push({
                        "mark": keyframe.mark,
                        "timing": keyframe.timing,
                        "motion": keyframe.motion,
                        "unit": {
                            "key": keyframe.unit.key,
                            [property]: keyframe.unit[property]
                        },
                    })
                })
            }
            if(keyframe.player != undefined) {
                Object.keys(keyframe.player).forEach((property) => {
                    if(property == "key") return
                    const timelineKey = "player" + "." + property

                    animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                    animation.timelines[timelineKey].push({
                        "mark": keyframe.mark,
                        "timing": keyframe.timing,
                        "motion": keyframe.motion,
                        "player": {
                            [property]: keyframe.player[property]
                        },
                    })
                })
            }

            // KEYFRAME SCHEMA v1 - a big object that had a type (to decide between
            // particles and units) and key, a bunch of meta tweening data, and then
            // all other keys were to be tween'd individually. and of course a mark for
            // when to make this frame happen!
            if(keyframe.unit == undefined) {
                Object.keys(keyframe).forEach((key) => {
                    if(key == "key"
                    || key == "mark"
                    || key == "type"
                    || key == "timing"
                    || key == "motion") {
                        return
                    }

                    // keyframe has many properties.
                    // key == property key

                    const timelineKey = (keyframe.key !== undefined ? keyframe.key + "." : "") + key

                    animation.timelines[timelineKey] = animation.timelines[timelineKey] || []
                    animation.timelines[timelineKey].push({
                        "key": keyframe.key,
                        "mark": keyframe.mark,
                        "type": keyframe.type,
                        "timing": keyframe.timing,
                        "motion": keyframe.motion,
                        [key]: keyframe[key]
                    })
                })
            }

            if(animation.maxmark < keyframe.mark + (keyframe.duration || 0)) {
                animation.maxmark = keyframe.mark + (keyframe.duration || 0)
            }
        })
        // console.log(JSON.stringify(animation.timelines["audio"]))
        // console.log(animation.timelines) // DEBUG

        // Sort each timeline.
        Objdict.forEach(animation.timelines, (timeline) => {
            timeline.sort((a, b) => {
                if(a.mark < b.mark) return -1
                if(a.mark > b.mark) return +1
                return 0
            })
        })

        return animation
    }
    static executeAnimation({animation, stage, currentDuration}) {
        const tweenFrame = {"mark": currentDuration}

        if(animation.timelines != undefined) {
            Objdict.forEach(animation.timelines, (timeline) => {
                while(timeline.length > 0
                && timeline[0] != undefined
                && timeline[0].mark < tweenFrame.mark) {
                    if(timeline[0].type == "log") {
                        Step.performFrame(stage, timeline[0])
                        timeline.shift()
                    } else if(timeline[0].do instanceof Function) {
                        timeline[0].do()
                        timeline.shift()
                    } else if(timeline[0].func instanceof Function) {
                        // this is not to be confused with step.func, this is step.deltastages[x].func.
                        timeline[0].func()
                    } else if(timeline[0].function instanceof Function) {
                        timeline[0].function()
                    } else if(timeline[0].audio != undefined) {
                        Step.performFrame(stage, timeline[0])
                        timeline.shift()
                    } else {
                        // Run this frame for every frame in-between

                        const previousFrame = timeline[0]
                        const nextFrame = timeline[1]
                        Step.performFrame(stage, previousFrame, tweenFrame, nextFrame)
                    }

                    if(timeline[1] != undefined
                    && timeline[1].mark < tweenFrame.mark) {
                        timeline.shift()
                        continue
                    } else {
                        return
                    }
                }
            })
        }
    }
    static performFrame(stage, previousFrame, tweenFrame, nextFrame) {
        tweenFrame = tweenFrame || previousFrame
        nextFrame = nextFrame || previousFrame

        const progress = Math.min(1, (tweenFrame.mark - previousFrame.mark) / (nextFrame.mark - previousFrame.mark))
        const timing = nextFrame.timing || Timings.linear
        const motion = nextFrame.motion || Motions.line

        if(previousFrame.dialogue != undefined) {
            stage.dialogue = stage.dialogue || {}
            stage.dialogue.text = previousFrame.dialogue.text
            stage.dialogue.tags = previousFrame.dialogue.tags
            stage.dialogue.index = previousFrame.dialogue.index
            stage.dialogue.type = previousFrame.dialogue.type
            stage.dialogue.data = previousFrame.dialogue.data
            // stage.dialogue.speakingCharacter = previousFrame.dialogue.speakingCharacter

            // stage.dialogue.characters = stage.dialogue.characters || {}
            // stage.dialogue.characters[stage.dialogue.speakingCharacter] = stage.dialogue.characters[stage.dialogue.speakingCharacter] || {}
            // stage.dialogue.characters[stage.dialogue.speakingCharacter].tags = stage.dialogue.characters[stage.dialogue.speakingCharacter].tags || {}
            // Objdict.forEach(previousFrame.dialogue.tags, (value, key) => {
            //     if(key == "_") return
            //     stage.dialogue.characters[stage.dialogue.speakingCharacter].tags[key] = value
            // })
            // COPIED FROM DELTA.JS
        }

        // KEYFRAME SCHEMA v2
        if(previousFrame.unit != undefined) {
            if(previousFrame.unit.key == undefined) {
                return
            }

            const unit = stage.units[previousFrame.unit.key]
            if(unit == undefined) return

            const previousUnit = previousFrame.unit
            const nextUnit = nextFrame.unit

            const UnitProperties = {
                "position": "motiontween",
                "opacity": "tween",
                "image": "static",
                "health": "static",
                "armor": "static",
                "inventory": "static",
                "affiliation": "static",
                // "static": the moment this becomes the previousFrame, it happens
                // "tween": so long as the previousFrame also has this property,
                // this will start tweening it to moment this becomes the nextFrame.
                // we do not currently check nextFrame at all, so if the previous
                // frame is missing it, we don't default it. that would be wild
                // to try coding, right? because we'd be assuming that this is
                // where the animation starts from, and would need to backfill
                // a frame for that before the next frame. yeah, that'd suck.
            }

            Object.keys(previousUnit).forEach((property) => {
                if(property == "key") return

                // for all of these tweens, do i need to be checking if
                // next frame exists? currently, it defaults to this previous
                // frame, which owuld mean i'm just tweening from me to me.
                // if next frame exists but the propety isn't there? should
                // i default it? woudl that ever happen with this system of
                // corraled units?

                if(previousUnit[property] == undefined) {
                    return
                }

                if(nextUnit[property] != undefined) {
                    if(UnitProperties[property] == "tween") {
                        unit[property] = tween(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                    if(UnitProperties[property] == "motiontween") {
                        unit[property] = motion(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                    if(UnitProperties[property] == "colortween") {
                        unit[property] = colortween(previousUnit[property], nextUnit[property], timing(progress))
                        return
                    }
                }

                // if(UnitProperties[property] == "static"
                // || UnitProperties[property] == undefined) {
                unit[property] = previousUnit[property]
                if(previousUnit[property] === null) {
                    unit[property] = undefined
                }

                // i am currently supporting null for disabling a property.
                // hey what does that mean if i try tweening between a valid
                // value and null???
            })
        }
        // This is still in the keyframe v2 schema, but is not tweening, just static jumps.
        if(previousFrame.player != undefined) {
            const previousPlayer = previousFrame.player
            const nextPlayer = nextFrame.player

            // todo: hey, why am I rewriting what I already wrote in delta.editStage..?
            // shouldn't i be callign that here?
            // oh, because of tweening, like in score.

            if(previousPlayer.score !== undefined
            && nextPlayer.score !== undefined) {
                // stage.player.score = previousPlayer.score
                stage.player.score = tween(previousPlayer.score, nextPlayer.score, timing(progress))
            }

            if(previousPlayer.inventory !== undefined) {
                if(previousPlayer.inventory.items != undefined) {
                    Objdict.forEach(previousPlayer.inventory.items, (item, key) => {
                        if(item == undefined) {
                            delete stage.player.inventory.items[key]
                        } else {
                            stage.player.inventory.items[key] = item
                        }
                    })
                }
            }
        }

        if(previousFrame.audio != undefined) {
            if(previousFrame.audio.triggerKey != undefined) {
                Audiomix.trigger(previousFrame.audio.triggerKey)
            }
        }

        // KEYFRAME SCHEMA v1
        // WHAT HAPPENS IF THE POSITION IS NOT DEFINED AND WE
        // STILL TRY TO TWEEN IT? BE SURE TO DEFAULT OR ABORT.
        if(previousFrame.type == "particle") {
            stage.particles = stage.particles || {}
            stage.particles[previousFrame.key] = stage.particles[previousFrame.key] || {}
            if(previousFrame.image != undefined) {
                stage.particles[previousFrame.key].image = previousFrame.image
            }if(previousFrame.space != undefined) {
                stage.particles[previousFrame.key].space = previousFrame.space
            }
            if(previousFrame.text != undefined) {
                stage.particles[previousFrame.key].text = previousFrame.text
            }
            if(previousFrame.stack != undefined) {
                stage.particles[previousFrame.key].stack = previousFrame.stack
            }
            if(previousFrame.color != undefined) {
                stage.particles[previousFrame.key].color = previousFrame.color
            }
            if(previousFrame.height != undefined) {
                stage.particles[previousFrame.key].height = previousFrame.height
            }
            if(previousFrame.width != undefined) {
                stage.particles[previousFrame.key].width = previousFrame.width
            }
            if(previousFrame.anchor != undefined) {
                stage.particles[previousFrame.key].anchor = previousFrame.anchor
            }
            if(previousFrame.scale != undefined) {
                if(nextFrame.scale != undefined) {
                    if(previousFrame.scale instanceof Object) {
                        stage.particles[previousFrame.key].scale = motion(previousFrame.scale, nextFrame.scale, timing(progress))
                    } else {
                        stage.particles[previousFrame.key].scale = tween(previousFrame.scale, nextFrame.scale, timing(progress))
                    }
                } else {
                    if(previousFrame.scale instanceof Object) {
                        stage.particles[previousFrame.key].scale = stage.particles[previousFrame.key].scale || {}
                        stage.particles[previousFrame.key].scale.x = previousFrame.scale.x
                        stage.particles[previousFrame.key].scale.y = previousFrame.scale.y
                    } else {
                        stage.particles[previousFrame.key].scale = previousFrame.scale
                    }
                }
            }
            if(previousFrame.tint != undefined) {
                stage.particles[previousFrame.key].tint = previousFrame.tint // TODO: tween
            }
            if(previousFrame.opacity != undefined && nextFrame.opacity != undefined) {
                stage.particles[previousFrame.key].opacity = tween(previousFrame.opacity, nextFrame.opacity, timing(progress))
            }
            if(previousFrame.position != undefined && nextFrame.position != undefined) {
                stage.particles[previousFrame.key].position = motion(previousFrame.position, nextFrame.position, timing(progress))
            }
            if(previousFrame.followTerrain != undefined) {
                const currentPosition = stage.particles[previousFrame.key].position
                if(currentPosition != undefined) {
                    const flooredPosition = { "x": Math.floor(currentPosition.x), "y": Math.floor(currentPosition.y) }
                    const terrain = World.getTerrain(stage.world, flooredPosition)
                    let zOverride = null
                    if(terrain != undefined) {
                        zOverride = terrain.size.z
                        if(previousFrame.followTerrain.zOffset != undefined) {
                            zOverride += previousFrame.followTerrain.zOffset
                        }
                    }

                    if(zOverride != null) {
                        stage.particles[previousFrame.key].zOverride = zOverride
                    } else {
                        stage.particles[previousFrame.key].zOverride = undefined
                    }
                }
            }
            if(previousFrame.anchor != undefined) { // && nextFrame.anchor != undefined) {
                stage.particles[previousFrame.key].anchor = previousFrame.anchor // motion(previousFrame.anchor, nextFrame.anchor, timing(progress))
            }
            if(previousFrame.rotation != undefined && nextFrame.rotation != undefined) {
                stage.particles[previousFrame.key].rotation = tween(previousFrame.rotation, nextFrame.rotation, timing(progress))
            }
            // TODO: this is done... when it's a previous frame, yeah? like health and the like? is that wieird?
            if(previousFrame.delete == true) {
                delete stage.particles[previousFrame.key]
            }
            return
        }

        if(previousFrame.type == "log") {
            stage.logs = stage.logs || []
            stage.logs.push({
                "text": previousFrame.text,
            })
            return
        }
    }
}
